module.exports = "<ng-container *ngFor=\"let row of userDevices\">\r\n  <app-device-information [userDevice]=\"row\"></app-device-information>\r\n</ng-container>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/on-demand-drivers/components/user-device/user-device.component.html
// module id = 2485
// module chunks = 66